import { render } from "./GoogleAd2.vue?vue&type=template&id=1d3266f6"
import script from "./GoogleAd2.vue?vue&type=script&lang=js"
export * from "./GoogleAd2.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__